import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Realmente funciona con adolescentes rebeldes?',
  a: 'Sí, porque se basa en biología, no en opinión. Al cambiar tu estímulo, su respuesta biológica cambia por necesidad.'
}, {
  q: '¿Es difícil de aprender?',
  a: 'No: son frases cortas y pasos simples diseñados para momentos de mucho estrés.'
}, {
  q: '¿Tengo que dejar de poner límites?',
  a: 'Al contrario: aprenderás a poner límites más firmes que realmente se cumplan.'
}, {
  q: '¿Qué pasa si mi hijo no quiere colaborar?',
  a: 'El sistema funciona aunque él no sepa que lo estás usando; el cambio empieza en tu comunicación.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-brand-cream-light px-4" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-21">
          <h2 className="text-3xl md:text-4xl text-brand-navy font-bold mb-4" data-id="element-22">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-23">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-white rounded-2xl shadow-sm border border-brand-cream overflow-hidden" data-id="element-24">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-25">
                  <span className="font-bold text-lg text-brand-navy pr-4" data-id="element-26">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="flex-shrink-0 text-brand-orange" data-id="element-27">
                    <ChevronDownIcon className="w-6 h-6" data-id="element-28" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-29">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-30">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-31">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}